export default __webpack_public_path__ + "media/easy-breezy.ffc6fab9.png";